angular.module('dpw.services').factory('dpwUserPermissionService', ['dpwUserRoleService', 'dpwAppAccessService', 'manageRoleAndAppAccessService', 'myAccountUtils', '$q', function (dpwUserRoleService, dpwAppAccessService, manageRoleAndAppAccessService, myAccountUtils, $q) {
    var UserRole = dpwUserRoleService.UserRole;
    var AppAccess = dpwAppAccessService.AppAccess;

    var UserAction = {
        CREATE_APP: 'Create an app',
        CLONE_APP: 'Clone an app',
        EDIT_ORG_NAME: 'Edit the organization\'s name',
        INVITE_NEW_DEVELOPER: 'Invite a new developer to this free account',
        MANAGE_ROLE_AND_APP_ACCESS: 'Manage role & app access for an user',
        MANAGE_DEVELOPER_LIST: 'Manage the developer list of the organization',
        SEE_ACTIONS_FOR_APPS: 'See the "Action" column in the app list',
        VIEW_MY_API_CREDENTIALS: 'View my API credentials',
        VIEW_API_CREDENTIALS_FOR_ANY_USER: 'View API credentials for any user',
        VIEW_SAMPLE_APP_SECRET: 'View sample app secret'
    };

    var userPermissions = {};

    userPermissions[UserAction.CREATE_APP] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    userPermissions[UserAction.CLONE_APP] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    userPermissions[UserAction.VIEW_SETUP_WIZARD] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    userPermissions[UserAction.EDIT_ORG_NAME] = [
        UserRole.Administrator
    ];

    userPermissions[UserAction.INVITE_NEW_DEVELOPER] = [
        UserRole.Administrator
    ];

    userPermissions[UserAction.MANAGE_ROLE_AND_APP_ACCESS] = [
        UserRole.Administrator
    ];

    userPermissions[UserAction.MANAGE_DEVELOPER_LIST] = [
        UserRole.Administrator
    ];

    userPermissions[UserAction.SEE_ACTIONS_FOR_APPS] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    userPermissions[UserAction.VIEW_MY_API_CREDENTIALS] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    userPermissions[UserAction.VIEW_API_CREDENTIALS_FOR_ANY_USER] = [
        UserRole.Administrator
    ];

    userPermissions[UserAction.VIEW_SAMPLE_APP_SECRET] = [
        UserRole.Administrator,
        UserRole.Developer
    ];

    var appAccessSettingsCache = null;
    var appAccessSettingsPromise = null;

    return {
        UserAction: UserAction,
        userPermissions: userPermissions,
        canManipulateApp: canManipulateApp,
        invalidateAppAccessSettingsCache: invalidateAppAccessSettingsCache
    };

    function canManipulateApp(appId) {
        return getAppAccessSettings().then(function (appAccessSettings) {
            if (appAccessSettings[appId] === AppAccess.ReadWrite) {
                return $q.resolve();
            }

            return $q.reject();
        })
    }

    function getAppAccessSettings() {
        if (appAccessSettingsCache) {
            return $q.resolve(appAccessSettingsCache);
        }

        if (appAccessSettingsPromise) {
            return appAccessSettingsPromise;
        }

        return appAccessSettingsPromise = $q(function (resolve) {
            manageRoleAndAppAccessService.fetchRolePermission().then(function (data) {
                appAccessSettingsCache = data.appAccessSettings;
                resolve(data.appAccessSettings);
            });
        });
    }

    function invalidateAppAccessSettingsCache() {
        appAccessSettingsCache = null;
        appAccessSettingsPromise = null;
    }
}]);
